<template>

    <BaseContainer>

        <header class="mb-6">
            
            <h1 class="text-gray-800 font-bold text-xl leading-none mb-2" v-text="$t('labels.conditions')"></h1>
        
            <Breadcrumbs :current="Route.CONDITION_INDEX"/>
        
        </header>

        <DataTable
            v-model:page="page"
            id="conditions"
            :columns="columns"
            :rows="rows"
            :transform="transform"
            :to="to"
            :from="from"
            :total="total"
            :pages="pages"
            :loading="loading"
            :filter="filter"
            :viewable="false"
            @edit="edit"
            @destroy="destroy">

            <template #actions>
                <BaseButton @click.prevent="create()"><i class="fa-duotone fa-circle-plus mr-2"></i>{{ $t('labels.condition-create') }}</BaseButton>
            </template>

        </DataTable>

        <BaseDrawer :title="$t(form?.mode === 'edit' ? 'labels.condition-edit' : 'labels.condition-create')">
            <ConditionForm ref="form"/>
        </BaseDrawer>

    </BaseContainer>

</template>

<script setup>  
    import { useConditionTypes, useI18n, useTrans } from '@/composables/i18n'
    import { useModelIndex } from '@/composables/model-ui'
    import Route from '@/constants/route'
    import { useConditionStore } from '@/store/model'

    const { t } = useI18n()
    const trans = useTrans()
    const store = useConditionStore()

    const types = useConditionTypes().map(status => ({
        value: status.id,
        text: status.text,
    }))

    const { rows, from, to, total, page, pages, loading, search, filter, destroy } = useModelIndex('condition', store, {
        created: t('message.condition-created'),
        updated: t('message.condition-updated'),
        destroyed: t('message.condition-destroyed')
    })

    const columns = computed(() => [
        { id: 'id', text: t('labels.id') },
        { id: 'name', text: t('labels.name') },
        { id: 'name_en', text: t('labels.name-en') },
        { id: 'name_fr', text: t('labels.name-fr') },
        { id: 'type', text: t('labels.type'), options: types },
        { id: 'created_at', text: t('labels.created') },
        { id: 'updated_at', text: t('labels.updated') },
    ])

    const form = ref()
    const create = () => form.value?.create()
    const edit = (id) => form.value?.edit(id)

    /**
     * Transform the specified row.
     *
     * @param {String} column
     * @param {Object} row
     * @return {String}
     */
    function transform (column, row) {
        switch (column) {
            case 'type': return t(`enum.condition-type.${row.type}`)
            case 'name': return trans({ en: row.name_en, fr: row.name_fr })
        }

        return row[column]
    }
</script>
